/**
 * 封装 fetch
 */
import moment from "moment";
import {put_auth_token_refresh} from "@/utils/paper.account";
import {jumpToLogin} from "@/utils/llm.tools";
// import {jy_tip} from "@/utils/vue.tool";
export let system_conf = window.system_conf || {
  umi_prefix: '',
};
export let {
  env,
  umi_prefix,
} = system_conf;
// 三个环境： KOBAS, KOBAS2, 开发环境
// const HostName = sessionStorage.getItem('hostname');
export const token_key = 'access-token';
export const xTokenKey = 'X-Authorization';
export const fileRoot = '/mnt/data/bioinfogpt/users/';
export const PaperScope = 'VIPaper';
export const PaperProduct = 'VIPaper';
export const fileDemosRoot = fileRoot + 'demos';
export const fileImagesRoot = '/mnt/data/bioinfogpt/tools/images/bioinfogpt';
// const service_info = {endpoint: HostName || `http://${hostname}`, 'port': 9003};
const {origin: ORIGIN, hostname} = window.location;
export const isDEV = hostname.startsWith('192.') || hostname.startsWith('http://localhost/');
umi_prefix = umi_prefix || '';
export const SYSTEM_CONF = system_conf;
export const WEB_ROOT = ORIGIN + umi_prefix;
// const service_info = {endpoint: HostName || `http://${ isDEV? 'bio.drai.cn':  hostname}`, 'port': 9003};
// export const tcm_api_prefix = HostName ? '' : `${service_info.endpoint }:${service_info.port || ''}`;
export const LocationOrigin = isDEV? 'http://www.vipaper.com': ORIGIN;
export const tcm_api_prefix = `${LocationOrigin}/web`;
export const UploadAction = tcm_api_prefix+ '/tcm/upload/file/';
export const UploadPdfAction = window.location.origin + '/api/v2/biogpt/aftergo/paper/upload/file/';
// 普通请求
export const authHeaders = (headers)=>{
  let token = localStorage.getItem(token_key);
  let xToken = localStorage.getItem(xTokenKey);
  if(token) headers['Authorization'] = `Basic ` + token;
  if(xToken) {
    headers[xTokenKey] = 'OAuth2 ' + xToken;
  }
  return headers;
};
export const jy_request_common =(rq, api_service=null) =>{
  let {
    url, api_info, headers, base_url, params
  } = rq;
  headers = headers || {};
  params = params || {};
  headers = {
    ...headers,
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    "Access-Control-Allow-Origin" : "*",
    "Access-Control-Allow-Credentials" : true,
  };

  let body;
  api_info = api_info || {};
  const {api_name, api_prefix} = api_info;
  let method = rq.type? rq.type.toLowerCase(): '';
  const action_name = method === 'get'? '获取': method === 'post'? '新建': method === 'put'? '更新': '删除';
  if(api_prefix) url = api_prefix + url.substring(1);
  if(!rq.crud_name) rq.crud_name = (action_name || '') + (api_name || url) + '信息';
  if(rq.data){
    if(method === 'get') params = {...params, ...rq.data};
    else body = JSON.stringify(rq.data);
  }

  if(url)headers['API-URL'] = url;
  if(api_service) headers['API-SERVICE'] = api_service;

  headers = authHeaders(headers);
  // if(method === 'delete') {headers['API-METHOD'] = method.toUpperCase();method = 'put'; }
  base_url = base_url || '';
  let endpoint = base_url.startsWith('http')? '': tcm_api_prefix;
  let fetch_url = `${endpoint + base_url}`;
  if(params) fetch_url += '?' + dict2params(params);
  if(rq.down){
    window.open(fetch_url);
    return;
  }
  return fetch(fetch_url, {
    method, headers: headers, body, mode: rq.mode || 'cors',
    "Access-Control-Allow-Origin" : "*",
    "Access-Control-Allow-Credentials" : true,
  })
    .then((promise) => {
      try {
        return promise.json();
      }
      catch (e) {
        return promise;
      }
    })
    .then((res) => {
      res = res || {status: -1};
      if(typeof res === 'string') res.message = res;
      else if(!res.message) res.message = '获取数据异常';
      if(res?.status === 1000101) {
        console.log(window.location.href);
        let {href} = window.location;
        if(href) localStorage.setItem('href', href);
        sessionStorage.setItem('href', href);
        // jy_tip(`请先登录`, 'error');
        // window.location.href = '/login';
      }
      else if([20401, 20403].indexOf(res?.status) > -1) {
        put_auth_token_refresh((res_refresh)=>{
          console.log('res_refresh', res_refresh);
          if(res_refresh?.data){
            let {user_info, access_token} = res?.data || {};
            if(user_info){
              localStorage.setItem('user_info', JSON.stringify(user_info));
              localStorage.setItem(xTokenKey, access_token);
              jy_request_common(rq, api_service);
            }
          } else {
            jumpToLogin();
          }
        })
      }
      else if(rq.success) return rq.success(res);
      else console.log(res);
    })
    .catch((err) => {
      if(rq.catch) rq.catch();
      else if(rq.redo)jy_request_common(rq, api_service);
      else if(rq.fail) rq.fail(err);
      else console.log(`${rq.crud_name}失败, 请稍后重试或者联系管理员.${err}` , 'error');
    });
};
export const jy_request_common_stream =(rq, api_service=null) =>{
  let token = localStorage.getItem('access-token');
  let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  let {url, api_info} = rq;
  let body;
  api_info = api_info || {};
  const {api_prefix} = api_info;
  let method = rq.type.toLowerCase();
  if(api_prefix) url = api_prefix + url.substring(1);
  if(rq.data){
    if(method === 'get') url += '?' + dict2params(rq.data);
    else body = JSON.stringify(rq.data);
  }
  if(url)headers['API-URL'] = url;
  if(api_service) headers['API-SERVICE'] = api_service;
  if(token) headers['Authorization'] = `Basic ` + token;

  if(method === 'delete') {headers['API-METHOD'] = method.toUpperCase();method = 'put'; }
  const fetch_url = `${tcm_api_prefix+rq.base_url}?${method === 'get' && rq.data? dict2params(rq.data): ''}`;
  if(rq.down){
    window.open(fetch_url);
    return;
  }
  return fetch(fetch_url, {method, headers: headers, body})
    .then((promise) => { return promise.json() })
    .then((res) => {
      res = res || {status: -1};
      if(!res.message) res.message = 'Request  exception';
      if(rq.success) rq.success(res);
      else console.log(res);
    })
    .catch(err => {console.log(`Unexpected error: ${err} You can send the error to the administrator email: budechao@ict.ac.cn.` , 'error'); });
};
export const jy_request = (rq, api_service=null) => {
  rq.base_url = rq.base_url || '/tcm/api/';
  return jy_request_common(rq, api_service);
};
export const jy_request_stream = (rq, api_service=null) => {
  rq.base_url = '/tcm/api/';
  return jy_request_common_stream(rq, api_service);
};


export const get_args = (url = "") => {
  if(url === '') url = window.location.search;
  const [, pStr = ""] = url.split('?'); // 使用解构赋值，避免了使用数组
  const args = {};
  pStr.split('&').map((it)=>{  // 箭头函数搭配map，避免了for循环，可以少定义变量
    const [k,v] = it.split('='); // 不用定义k，v并分开赋值，直接赋值 简化代码
    if(k)args[k]=decodeURIComponent(v);
  });
  return args;
};
export const dict2params = (dict) => {
  let params = '';
  Object.keys(dict).forEach(function (key) {
    params += `${key}=${dict[key]}&`;
  });
  return params.substring(0, params.length-1);
};

// api请求
export const api_request = (rq) => jy_request(rq, 'api');


// 排序
export function cmp(a, b) {
  if(a > b) return 1;
  else if(a===b) return 0;
  else return -1;
}
// 排序
export let compare =(key, dataType)=>{
  return (a, b) =>{
    let v1 = a[key];
    let v2 = b[key];
    if(dataType === 'number') {
      v1 = Number(v1);
      v2 = Number(v2);
    }
    return cmp(v1, v2);
  }
};
export const jy_sort = (a, b, k) => {
  //小的在前，大的在后，一样的不交换。-1不交换，1交换
  if(!k) return cmp(a, b);
  if(!a && !b) return 0;
  if(!a && b) return -1;
  if(!b) return 1;
  if(a[k] && b[k])  {
    if(Array.isArray(a[k])) {
      console.log(a[k].length, b[k].length);
      return cmp(a[k].length, b[k].length);
    }
    return cmp(a[k], b[k]);
  }
  if(a[k] && !b[k]) return 1;
  if(!a[k] && b[k]) return -1;
  return false;
};
// 列设置
export const get_column = (title, key, sorted_info, others) => {
  others = others || {};
  return {
    title,
    dataIndex: key,
    columnKey: key,
    key,
    //defaultSortOrder: 'descend',
    sorter: (a, b) => {return jy_sort(a, b, key)},
    sortOrder: sorted_info? sorted_info.columnKey === key && sorted_info.order: false,
    ...others
  };
};

export const sort_columns = (columns, isEditing)=>{
  return columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    const {title, key, sorted_info, others} = col;
    col = get_column(title, key, sorted_info, others);
    return {
      ...col,
      onCell: record => ({
        record,
        //editable: col.editable,
        dataIndex: col.dataIndex,
        key: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
};

export const float2percent = (f, sign='%') =>parseInt(f * 10000) / 100 + sign;
//验证手机号
export const check_phone = (value, callback) => {
  if(value){
    if(!/^1[\d]{10}$/.test(value))callback('请输入11位有效手机号');
    else callback();
  } else callback();
};
export const checkInfile = (intype, text) =>{
  // 如果粘贴
  // 1）blast <500 (统计>号开头的行数)
  // 2）blastout <3000(统计第二列的唯一ID数目)
  // 2）ID<3000   (统计行数)
  let lines = text.split('\n');
  if(['Fasta Protein Sequence','Fasta Nucleotide Sequence'].indexOf(intype) > -1){
    // blast
    let n = lines.filter((l) => l.startsWith('>')).length;
    if(n < 500) return false;
    else return `The input sequence number of ${intype} should be less than 500.`
  } else if(['Tabular BLAST Output'].indexOf(intype) > -1){
    // blast
    let uniqIDs = [];
    lines.map(line=>{
      if(line){
        let arr = line.split('\t');
        let bID = arr[1];
        if(uniqIDs.indexOf(bID) === -1) uniqIDs = [...uniqIDs, bID];
      }
    });
    if(uniqIDs.length < 3000) return false;
    return 'The input subject sequence number of Tabular BLAST Output should be less than 3000.';
  } else {
    if(lines.length < 3000) return false;

    return `${lines.length}, The input number of ${intype} should be less than 3000.`
  }
};
export const checkFile = (intype) =>{
  //Enrichment
  // 如果传文件
  // 1）blast  <10M
  // 2)  ID  <50K
  let maxSize;
  let errMsg = '';
  if(['Fasta Protein Sequence','Fasta Nucleotide Sequence', 'Tabular BLAST Output'].indexOf(intype) > -1){
    // blast
    maxSize = 10 * 1024 * 1024;
    errMsg = '10M';
  } else if(intype === 'multi') {
    maxSize = 10 * 1024 * 1024;
    errMsg = '10M';
  } else {
    maxSize = 50 * 1024;
    errMsg = '50K';
  }
  return {maxSize, errMsg: `The input file size of ${intype} should be less than ${errMsg}.`};
};



// 复制输入框中的值
export const copyInputValue = (selector, func) => {
  let copyDom = document.querySelector(selector);
  const currentFocus = document.activeElement; // 获取页面上正在被选中的对象
  copyDom.focus();
  let {value, text} = copyDom;
  value = value || text || '';
  copyDom.setSelectionRange(0, value.length); // 方法可以从一个被 focused 的 <input> 元素中选中特定范围的内容。
  // document.execCommand("copy", true);
  let successful = document.execCommand('copy', true);
  if(successful) {
    if(func) func('已复制结果到粘贴板上', 'success');
  }
  else console.log('复制失败，请手动复制');
  currentFocus.focus();
};

//查询任务
export const get_task = (task_id, success) => {
  api_request({
    url: `/${task_id}/`,
    type: 'get',
    success,
    api_info: {api_name: "查询任务", api_prefix: "/task/"}
  });
};


//查询任务log
export const get_task_log = (task_id, success) => {
  api_request({
    url: `/${task_id}/log/`,
    type: 'get',
    success,
    api_info: {api_name: "查询任务日志", api_prefix: "/task/"}
  });
};
//提交任务
export const post_task = (url, data, success) => {
  api_request({
    data,
    type: 'post',
    url: url,
    success,
    api_info: {api_name: "提交任务", api_prefix: ""}
  });
};


export const down_file = (res, func)=>{
  jy_request_common({
    down: true,
    data: res,
    type: 'GET',
    base_url: '/tcm/download/',
    url: '',
    success: func
  })
};


export const delete_file = (res, func)=>{
  jy_request_common({
    data: res,
    type: 'delete',
    base_url: '/tcm/delete/file/',
    url: '',
    success: func
  })
};
export const down_file_demo = (file_name, attachment_filename)=>{
  let {test} = system_conf;
  if(test && (!test.endsWith('/'))) test += '/';
  let file_path = test + file_name;
  let rq = {file_path};
  rq = {...rq, attachment_filename: (attachment_filename || file_name)};
  down_file(rq);
};
//保存文件
export const save_file = (res, func)=>{
  jy_request_common({
    data: res,
    type: 'POST',
    base_url: '/tcm/save/file/',
    url: '',
    success: func
  })
};
//获取文件内容
export const get_file_content = (res, func)=>{
  jy_request_common({
    data: res,
    type: 'POST',
    base_url: '/file/content/',
    url: '',
    success: func
  })
};
export const string2array = (data, sep='\t', noHeader=false)=>{
  let lines = data.split('\n');
  let ths = lines[0].split(sep);
  let lines2 = lines.slice(1, lines.length);
  if(noHeader) lines2 = lines;
  data = lines2.map((line)=>{
    let ds = line.split(sep);
    if(noHeader) return ds;
    let item = {};
    ds.map((d1, index)=>{
      item = {...item, [ths[index]]: d1}
    });
    return item;
  });
  return data;
};


export const transfer_img = (file_path, func)=>{
  jy_request_common({
    data: {file_path},
    type: 'POST',
    base_url: '/transfer/img/',
    url: '',
    success: func
  })
};

export const get_file = (rq, func)=>{
  jy_request_common({
    type: 'POST',
    base_url: '/tcm/file/',
    data: rq,
    success: func
  })
};

export const new_folder = (rq, func)=>{
  jy_request_common({
    type: 'POST',
    base_url: '/tcm/folder/',
    data: rq,
    success: func
  })
};


export const getSaveAsImg = (name, imgType='png')=>{
  return {
    toolbox: {
      right: 0,
      bottom: 0,
      feature: {
        saveAsImage: {
          name,
          type: imgType,
          show: true,
          pixelRatio: 5,
          title: 'Save the figure',
          icon: 'M 893.3 293.3 L 730.7 130.7 c -7.5 -7.5 -16.7 -13 -26.7 -16 V 112 H 144 c -17.7 0 -32 14.3 -32 32 v 736 c 0 17.7 14.3 32 32 32 h 736 c 17.7 0 32 -14.3 32 -32 V 338.5 c 0 -17 -6.7 -33.2 -18.7 -45.2 Z M 384 184 h 256 v 104 H 384 V 184 Z m 456 656 H 184 V 184 h 136 v 136 c 0 17.7 14.3 32 32 32 h 320 c 17.7 0 32 -14.3 32 -32 V 205.8 l 136 136 V 840 Z M 512 442 c -79.5 0 -144 64.5 -144 144 s 64.5 144 144 144 s 144 -64.5 144 -144 s -64.5 -144 -144 -144 Z m 0 224 c -44.2 0 -80 -35.8 -80 -80 s 35.8 -80 80 -80 s 80 35.8 80 80 s -35.8 80 -80 80 Z'
        },
        dataView: {
          show: false
        }
      }
    },
  };
}
export const string2arraySimple = (data, sep='\t')=>{
  let lines = data.split('\n').filter((l)=> l !== '');
  data = lines.map((line)=> line.split(sep));
  return data;
};

export const formatTime = (timeStamp) => {
    if(isNaN(timeStamp)) return timeStamp;
    let now = new Date();
    timeStamp *= 1000;
    let diff = now - timeStamp;
    let ms = 24 * 60 * 60 * 1000;
    if(diff <= ms) return moment(timeStamp).format('HH:mm');
    return moment(timeStamp).format('YYYY-MM-DD HH:mm:ss');
};
export const get_ref_color = (Impact_Factor_2022)=>{
  let color = '';
  if(['NA', null, ''].indexOf(Impact_Factor_2022) > -1) color = '#A6A6A6';
  else if (Impact_Factor_2022 >= 0 && Impact_Factor_2022 <=5) color = '#5B9BD5';
  else if (Impact_Factor_2022 > 5 && Impact_Factor_2022 <= 10) color = '#70AD47';
  else if (Impact_Factor_2022 > 10 && Impact_Factor_2022 <= 20) color = '#FFC000';
  else if(Impact_Factor_2022 > 20) color = '#FF0000';
  console.log('xxxxx====', Impact_Factor_2022, ['NA', null, ''].indexOf(Impact_Factor_2022) > -1);
  return color
};
